import script from "./SelectInsuranceComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectInsuranceComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__